import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


import 'ckeditor5/ckeditor5.css';
import 'ckeditor5-premium-features/ckeditor5-premium-features.css';
import { Breadcrumbs, Typography } from '@mui/material'
import { Button, Card, Col, Label, Row } from 'reactstrap'
import { Link } from 'react-router-dom'


function AddNews() {
    return (
        <div>
            <div className='box'>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        Dashboard
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>List</Typography>
                </Breadcrumbs>
            </div>
            <div className='text-inner'>
                <Card className='px-5 py-5' >
                    <div>
                        <label>News title <span className='text-danger'>*</span></label>
                        <input type='text' className='form-control'
                        />
                    </div>
                    <div>
                        <label>News date <span className='text-danger'>*</span></label>
                        <input type='date' className='form-control'
                        />
                    </div>
                    <Label>News body</Label>
                    <CKEditor
                            editor={ClassicEditor}
                            data="<p>Type your content here...</p>"
                            config={{
                                toolbar: [
                                    'heading', '|', 'bold', 'italic', 'link', 'blockQuote', 'code', '|',
                                    'bulletedList', 'numberedList', 'todoList', '|',
                                    'outdent', 'indent', '|', 'alignment', 'fontSize', 'fontColor', 'fontBackgroundColor', '|',
                                    'imageUpload', 'mediaEmbed', 'insertTable', 'tableProperties', 'tableCellProperties', '|',
                                    'undo', 'redo'
                                ],
                                // Optional: Customize other configuration options
                                image: {
                                    toolbar: [
                                        'imageTextAlternative', 'imageStyle:full', 'imageStyle:side', '|',
                                        'imageResize:25', 'imageResize:50', 'imageResize:75', 'imageResize:100'
                                    ]
                                }
                            }}
                        />
                </Card>

            </div>
        </div>

    );
}

export default AddNews